// Modules
import styled from "styled-components"

// Constants
import colors from "~constants/colors"

export const ErrorMessageSmall = styled.p`
  color: ${colors.red};
  font-size: 12px;
  font-weight: bold;
  height: 20px;
  line-height: 20px;
  margin: 0;
`
